export const MAXIMUM_TASK_NAME_LENGTH = 512;

export interface SubmitToSandboxPanelWebComponentSchema {
  targetName: string;
}

export interface SubmitToSandboxTaskData {
  targetName: string;
  taskName: string;
  specifics: SubmitToSandboxTaskDataSpecifics;
}

export interface SubmitToSandboxTaskDataSpecifics {
  files: SampleFile[];
  execute: ExecuteCommand[];
}

export interface SampleFile {
  path: string;
}

export interface ExecuteCommand {
  commandLine: string;
}

export enum SubmitToSandboxPanelEvents {
  OnPanelClose = 'submitToSandboxPanelEventClose',
}
